import styled from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, maxWidth } from 'theme/theme';

export const OrgLayoutHeader = styled.header`
  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    margin-bottom: 16px;
    margin-top: 32px;
  }
`;

export const OrgLayoutFooterHolder = styled.div`
  background: ${colors.backgroundGrey};
  margin-top: 70px;
  padding: 70px 0;
  text-align: center;
`;

export const OrgLayoutFooterWrapper = styled.div`
  margin: 0 auto;
  max-width: ${maxWidth[3]}px;
  padding: 0 ${gutterWidth / 2}px;
`;

export const OrgLayoutSidebarTitle = styled.div`
  /* block-no-empty */
`;
